'use es6';

import { BATTLESHIP, HEFFALUMP, KOALA, OLAF } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const BoxIcon = ({
  dark,
  width,
  height
}) => /*#__PURE__*/_jsx("div", {
  style: {
    flexGrow: width,
    backgroundColor: dark ? KOALA : OLAF,
    borderColor: dark ? BATTLESHIP : HEFFALUMP,
    borderWidth: '1px',
    borderStyle: 'solid',
    height: `${height}px`,
    margin: '0 2px'
  }
});
const ColumnLayoutIcon = ({
  columnWidths,
  dark,
  height = 22
}) => /*#__PURE__*/_jsx("div", {
  style: {
    display: 'flex',
    justifyContent: 'space-between',
    flexGrow: 1,
    margin: '0'
  },
  children: columnWidths.map((width, index) => /*#__PURE__*/_jsx(BoxIcon, {
    width: width,
    dark: dark,
    height: height
  }, index))
});
export default ColumnLayoutIcon;